import {
  rankWith,
  isStringControl,
  isNumberControl,
  isIntegerControl,
  isBooleanControl,
  isEnumControl,
  RankedTester,
} from "@jsonforms/core";

import { TextCell } from "./cells/TextCell";
import { NumberCell } from "./cells/NumberCell";
import { CheckboxCell } from "./cells/CheckboxCell";
import { EnumCell } from "./cells/EnumCell";

export const textCellTester: RankedTester = rankWith(2, isStringControl);
export const numberCellTester: RankedTester = rankWith(2, isNumberControl);
export const integerCellTester: RankedTester = rankWith(2, isIntegerControl);
export const booleanCellTester: RankedTester = rankWith(2, isBooleanControl);
export const enumCellTester: RankedTester = rankWith(2, isEnumControl);

export const cells = [
  { tester: textCellTester, cell: TextCell },
  { tester: numberCellTester, cell: NumberCell },
  { tester: integerCellTester, cell: NumberCell },
  { tester: booleanCellTester, cell: CheckboxCell },
  { tester: enumCellTester, cell: EnumCell },
];
